import { isMealPlanMain } from 'common/MealPlanUtils';
import type { MealPlanCartItem } from 'src/ztore/cart-store';

/**
 * Main cart quantities are stored in servings; convert to whole units (meals) for display.
 * Sides and add-ons are stored 1:1, so they pass through. Callers must ensure `numServings >= 1`.
 */
export const getQuantityInUnits = (item: MealPlanCartItem, numServings: number): number => {
  if (!isMealPlanMain(item.foodItem)) return item.quantity;
  return Math.round(item.quantity / numServings);
};
